import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import authProvider from "../react-admin/providers/authProvider";

export const Auth = () => {
  const navigate = useNavigate();
  const handleLogin = async (googleData: any) => {
    try {
      await authProvider.login(googleData);
      navigate("/");
    } catch (e) {
      return navigate("/unauthorized");
    }
  };

  useEffect(() => {
    const fragmentString = window.location.hash.substring(1);
    // Parse query string to see if page request is coming from OAuth 2.0 server.
    const params = {};
    const regex = /([^&=]+)=([^&]*)/g;
    let m: any = "";
    while ((m = regex.exec(fragmentString))) {
      //@ts-ignore
      params[decodeURIComponent(m[1])] = decodeURIComponent(m[2]);
    }
    handleLogin(params);
  }, []);
  return null;
};
